import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { memo } from "react";
import { FieldErrors } from "react-hook-form";

interface FormErrorDisplayProps {
  formErrors: FieldErrors;
  apiError?: Error | null;
  fieldOrder?: string[];
}

export const FormErrorDisplay = memo(function FormErrorDisplay({
  formErrors,
  apiError,
  fieldOrder = [],
}: FormErrorDisplayProps) {
  const firstFormError = fieldOrder.find((fieldName) => formErrors[fieldName]);
  const formErrorMessage = firstFormError
    ? formErrors[firstFormError]?.message
    : null;

  const errorMessage = formErrorMessage || apiError?.message;

  if (!errorMessage) {
    return null;
  }

  const testId = formErrorMessage
    ? `${firstFormError}-error-message`
    : "api-error-message";

  return (
    <div
      data-testid={testId}
      className={cn(textVariants.bodySmall, "text-text-input-error-default")}
    >
      {errorMessage?.toString()}
    </div>
  );
});
